import React from 'react';
import { Facebook } from 'lucide-react';

const Help = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* VideBits Logo */}
            <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="/logo-transparent.svg" 
                alt="VideBits Logo" 
                className="w-8 h-8"
              />
              <h1 className="text-xl font-light text-gray-900">VideBits</h1>
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-videbits-500 shadow-2xl rounded-lg text-center px-6 py-12">
            <div className="mb-4">
              <h1 className="text-2xl text-white mb-6">Help & Support</h1>
              
              <div className="text-base px-6 text-videbits-100 text-left space-y-4">
                <h2 className="text-lg text-white font-semibold">How to Search</h2>
                <p>
                  Simply enter your search terms in the search bar on the home page. You can search for movie titles, TV series, actors, directors, or any keywords related to the content you're looking for.
                </p>
                
                <h2 className="text-lg text-white font-semibold">Search Tips</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>Use specific keywords for better results</li>
                  <li>Try different variations of titles or names</li>
                  <li>Search results are ranked by relevance</li>
                  <li>Recent searches are saved for quick access</li>
                </ul>
                
                <h2 className="text-lg text-white font-semibold">Frequently Asked Questions</h2>
                
                <div className="space-y-3">
                  <div>
                    <h3 className="text-white font-medium">Q: How do I find specific content?</h3>
                    <p>A: Use the search bar with specific titles, actor names, or keywords. Our search engine will find relevant matches across our database.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-white font-medium">Q: Why can't I find certain content?</h3>
                    <p>A: Our database is constantly expanding. If you can't find specific content, it may not be indexed yet or may be available through external links.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-white font-medium">Q: Is VideBits free to use?</h3>
                    <p>A: Yes, VideBits is free to use for searching and discovering video content.</p>
                  </div>
                </div>
                
                <h2 className="text-lg text-white font-semibold">Contact Support</h2>
                <p>
                  If you need further assistance or have questions not covered here, please contact our support team at <a href="mailto:support@videbits.com" className="text-white underline hover:no-underline">support@videbits.com</a>.
                </p>
                
                <p>
                  We typically respond to support requests within 24 hours during business days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-1 md:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <a href="/about" className="hover:underline">About</a>
              <a href="/privacy" className="hover:underline">Privacy</a>
              <a href="/terms" className="hover:underline">Terms</a>
              <a href="/help" className="hover:underline">Help</a>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <a
                href="https://www.facebook.com/videbits"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="VideBits on Facebook"
                className="hover:text-gray-900 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <span>© {new Date().getFullYear()} VideBits Ltd</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Help;